import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async () => {
    setMessage("");
    setError("");
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Reset link has been sent to your email.");
    } catch (err) {
      setError("Error: " + err.message);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#0e1a2b",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "#1c2a3a",
          padding: "30px 20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
          width: "100%",
          maxWidth: "400px",
          color: "#fff",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Reset Password
        </h2>

        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your Email"
          type="email"
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "5px",
            border: "1px solid #2c3e50",
            backgroundColor: "#243447",
            color: "#fff",
          }}
        />

        <button
          onClick={handleReset}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#ff9d00",
            color: "#000",
            fontWeight: "bold",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            marginBottom: "15px",
          }}
        >
          Send Reset Email
        </button>

        {message && (
          <p
            style={{
              color: "#2ecc71",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            {message}
          </p>
        )}
        {error && (
          <p
            style={{
              color: "#e74c3c",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            {error}
          </p>
        )}

        <p style={{ textAlign: "center", fontSize: "14px" }}>
          <a
            href="/customers/login"
            style={{ color: "#fffffa", textDecoration: "underline" }}
          >
            Back to Login
          </a>
        </p>
      </div>
    </div>
  );
}

// import { useState } from "react";
// import { sendPasswordResetEmail } from "firebase/auth";
// import { auth } from "../../firebase";

// export default function ForgotPassword() {
//   const [email, setEmail] = useState("");

//   const handleReset = async () => {
//     try {
//       await sendPasswordResetEmail(auth, email);
//       alert("Reset link sent to your email");
//     } catch (err) {
//       alert("Error: " + err.message);
//     }
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         backgroundColor: "#0e1a2b",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: "20px",
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: "#1c2a3a",
//           padding: "30px 20px",
//           borderRadius: "10px",
//           boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
//           width: "100%",
//           maxWidth: "400px",
//           color: "#fff",
//         }}
//       >
//         <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
//           Reset Password
//         </h2>

//         <input
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           placeholder="Your Email"
//           type="email"
//           style={{
//             width: "100%",
//             padding: "10px",
//             marginBottom: "20px",
//             borderRadius: "5px",
//             border: "1px solid #2c3e50",
//             backgroundColor: "#243447",
//             color: "#fff",
//           }}
//         />

//         <button
//           onClick={handleReset}
//           style={{
//             width: "100%",
//             padding: "12px",
//             backgroundColor: "#ff9d00",
//             color: "#000",
//             fontWeight: "bold",
//             border: "none",
//             borderRadius: "5px",
//             cursor: "pointer",
//             marginBottom: "15px",
//           }}
//         >
//           Send Reset Email
//         </button>

//         <p style={{ textAlign: "center", fontSize: "14px" }}>
//           <a
//             href="/customers/login"
//             style={{ color: "#fffffa", textDecoration: "underline" }}
//           >
//             Back to Login
//           </a>
//         </p>
//       </div>
//     </div>
//   );
// }

// import { useState } from "react";
// import { sendPasswordResetEmail } from "firebase/auth";
// import { auth } from "../../firebase";

// export default function ForgotPassword() {
//   const [email, setEmail] = useState("");

//   const handleReset = async () => {
//     try {
//       await sendPasswordResetEmail(auth, email);
//       alert("Reset link sent to your email");
//     } catch (err) {
//       alert("Error: " + err.message);
//     }
//   };

//   return (
//     <div>
//       <h2>Reset Password</h2>
//       <input
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         placeholder="Your Email"
//       />
//       <button onClick={handleReset}>Send Reset Email</button>
//     </div>
//   );
// }
